<ng-container *ngIf="!isDialogMode">
  <app-breadcrumb></app-breadcrumb>

  <div class="bpaas-title">功能標題 (單檔)</div>
</ng-container>

<p-menubar [model]="masterMenu" class="bpaas-master-menubar bpaas-dialog-top-sticky" [id]="parseToId('masterMenu')">
</p-menubar>

<div class="bpaas-content">
  <form [formGroup]="formGroup">
    <p-panel [showHeader]="false">
      <div class="card" #contentElement pBPaaSFocusTrap>
        <div class="grid p-fluid">
          <div class="col-12 md:col-3 lg:col-3">
            <label class="bpaas-required">文字輸入</label>
            <input type="text" pInputText
              formControlName="input" [id]="parseToId('input')"
              [ngClass]="{'ng-dirty': formControlInvalid('input')}">
            <div *ngIf="formControlInvalid('input')">
              <small class="p-error"
                *ngIf="formControl('input').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label class="bpaas-required">選擇日期</label>
            <p-calendar [showIcon]="true" appendTo="body"
              formControlName="calendar" dateFormat="yy/mm/dd" dataType="string"
              placeholder="yyyy/mm/dd" [inputId]="parseToId('calendar')"
              [showOnFocus]="false"
              [ngClass]="{'ng-dirty': formControlInvalid('calendar')}">
            </p-calendar>
            <div *ngIf="formControlInvalid('calendar')">
              <small class="p-error"
                *ngIf="formControl('calendar').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label>日期區間</label>
            <p-calendar [showIcon]="true" appendTo="body"
              dateFormat="yy/mm/dd" dataType="string"
              selectionMode="range" formControlName="calendarRange"
              [showOnFocus]="false"
              [inputId]="parseToId('calendarRange')">
            </p-calendar>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label>數字輸入</label>
            <p-inputNumber formControlName="inputNumber" [inputId]="parseToId('inputNumber')"></p-inputNumber>
          </div>
        </div>
        <div class="grid p-fluid">
          <div class="col-12 md:col-3 lg:col-3">
            <label>下拉選單 (固定選項)</label>
            <p-dropdown *ngIf="langChangeVisible"
              [options]="exampleOptions"
              placeholder="{{ 'option.please-select' | translate }}" [showClear]="true"
              formControlName="dropdown" [inputId]="parseToId('dropdown')">
            </p-dropdown>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label>自動完成</label>
            <p-autoComplete *ngIf="langChangeVisible"
              [suggestions]="exampleDataSuggestions"
              [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true"
              [showEmptyMessage]="true" emptyMessage="{{ 'table.no-records-found' | translate }}"
              (completeMethod)="searchExampleDataSuggestions($event)"
              (onClear)="autoCompleteCleared('autoComplete')"
              (onFocus)="autoCompleteFocus($event)"
              (onBlur)="autoCompleteBlur($event)"
              (onKeyUp)="autoCompleteKeyUp($event)"
              (onSelect)="autoCompleteCompleted('autoComplete')"
              formControlName="autoComplete" [inputId]="parseToId('autoComplete')"
              field="{{ 'exampleDataName' | translateFieldName: 'exampleDataName' }}">
              <ng-template let-exampleData pTemplate="item">
                {{ exampleData.exampleDataCode }} {{ exampleData.exampleDataName | translateDataValue: exampleData : 'exampleDataName' }}
              </ng-template>
            </p-autoComplete>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label>動態下拉 (資料少適用)</label>
            <p-dropdown *ngIf="langChangeVisible"
              [options]="dynamicOptions"
              optionLabel="{{ 'label' | translateFieldName: 'label' }}"
              optionValue="value"
              placeholder="{{ 'option.please-select' | translate }}" [showClear]="true"
              appendTo="body"
              formControlName="dynamicDropdown" [inputId]="parseToId('dynamicDropdown')">
            </p-dropdown>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label>自動完成+下拉 (資料少適用)</label>
            <p-autoComplete *ngIf="langChangeVisible"
              [suggestions]="allExampleDataSuggestions"
              [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true"
              [showEmptyMessage]="true" emptyMessage="{{ 'table.no-records-found' | translate }}"
              (completeMethod)="searchAllExampleDataSuggestions($event)"
              (onClear)="autoCompleteCleared('autoCompleteDropdown')"
              (onFocus)="autoCompleteFocus($event)"
              (onBlur)="autoCompleteBlur($event)"
              (onKeyUp)="autoCompleteKeyUp($event)"
              (onSelect)="autoCompleteCompleted('autoCompleteDropdown')"
              [dropdown]="true" dropdownMode="blank"
              formControlName="autoCompleteDropdown" [inputId]="parseToId('autoCompleteDropdown')"
              field="{{ 'exampleDataName' | translateFieldName: 'exampleDataName' }}">
              <ng-template let-exampleData pTemplate="item">
                {{ exampleData.exampleDataCode }} {{ exampleData.exampleDataName | translateDataValue: exampleData : 'exampleDataName' }}
              </ng-template>
            </p-autoComplete>
          </div>
        </div>
        <div class="grid p-fluid">
          <div class="col-12 md:col-3 lg:col-3">
            <label>自訂欄位驗證 ( 不能輸入 1 )</label>
            <input type="text" pInputText
              formControlName="custValidation" [id]="parseToId('custValidation')"
              [ngClass]="{'ng-dirty': formControlInvalid('custValidation')}">
            <div *ngIf="formControlInvalid('custValidation')">
              <small class="p-error"
                *ngIf="formControl('custValidation').errors?.['duplicate']">
                {{ 'message.validation.duplicate' | translate }}
              </small>
            </div>
          </div>
        </div>
      </div>
    </p-panel>
  </form>
</div>
